import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { Pencil } from "lucide-react";
import { useSelector } from "react-redux";
import baseUrl from "../../api/universalApi";

const fields = [
  { key: "creator_name", label: "Name" },
  { key: "pancard", label: "PAN Card" },
  { key: "aadhar_card", label: "Aadhar Card" },
  { key: "gst", label: "GST (Optional)" },
  { key: "emergency_poc_name", label: "Emergency POC Name" },
  { key: "emergency_poc_contact", label: "Emergency POC Contact Number" },
  { key: "bank_account_number", label: "Bank Account Number" },
  { key: "bank_ifsc", label: "Bank IFSC" },
  { key: "bank_name", label: "Bank Name" },
];

const VrfDetails = ({formState,setFormState,vrfDetails,setVrfDetails}) => {
  const [open, setOpen] = useState(false);
  //const [formState, setFormState] = useState({});
  const creatorData = useSelector((state) => state.auth?.authData?.user); // Assuming you have a Redux store or context for creator data
  // console.log("Creator Data:", creatorData);

  const handleChange = (key, value) => {
    setFormState((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    try {
      await axios.post(`${baseUrl}/api/agreement/createVrfDetails`, {
        creatorId: creatorData._id,
        vrfDetails: formState,
      });
      setVrfDetails(formState);
      setOpen(false);
    } catch (err) {
      console.error("Failed to save VRF details", err);
    }
  };

  return (
    <div className="p-4 border rounded-lg shadow-md space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold">VRF Details</h2>
        <button
          className="p-2 rounded-full border hover:bg-gray-100"
          onClick={() => setOpen(true)}
        >
          <Pencil size={18} />
        </button>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {fields.map(({ key, label }) => (
          <div key={key} className="text-sm">
            <span className="font-medium">{label}:</span>{" "}
            {vrfDetails?.[key] || "--"}
          </div>
        ))}
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 bg-black/30 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-xl p-6 w-full max-w-2xl shadow-xl"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
            >
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">Update VRF Details</h3>
                <button
                  onClick={() => setOpen(false)}
                  className="text-gray-600 hover:text-black"
                >
                  ✕
                </button>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {fields.map(({ key, label }) => (
                  <div key={key}>
                    <label className="text-sm font-medium block mb-1">
                      {label}
                    </label>
                    <input
                      className="w-full border px-3 py-2 rounded-md text-sm"
                      value={formState[key] || ""}
                      onChange={(e) => handleChange(key, e.target.value)}
                    />
                  </div>
                ))}
              </div>
              <div className="flex justify-end pt-4">
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default VrfDetails;
